module.exports = __webpack_public_path__ + "static/media/cyoa-rover.caa01e27.mp3";